export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.7.1';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = f06t
// module chunks = 0